import React, { useState } from 'react';
import axios from 'axios';
import { useAppConfig } from '../../AppConfigProvider';
import { toast, ToastContainer } from 'react-toastify';
import logo from '../../images/Docusync-logo.svg';
import { Link } from 'react-router-dom';

const ForgotPassword = () => {
    const appConfig = useAppConfig();
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await axios.post(`${appConfig.backendUrl}api/v1/auth/forgot-password`, { email });
            toast.success(response.data.message || 'Reset link sent to your email!');
        } catch (error) {
            toast.error(error.response?.data?.message || 'Error requesting password reset.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-page d-flex align-items-center justify-content-center min-vh-100">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-6 col-lg-5 col-md-7 col-sm-9 col-11">
                        <div className="card shadow-lg border-0 rounded-4 my-2 my-md-4">
                            <div className="card-body p-4 p-md-4">
                                <div className="text-center mb-3">
                                    <img src={logo} alt="logo" className="logo-img img-fluid mb-2" style={{ maxWidth: '100px' }} />
                                    <h2 className="fw-bold fs-3" style={{ color: '#2c3e50' }}>Forgot Password</h2>
                                    <p className="text-muted small">Enter your email to receive a reset link</p>
                                </div>
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <input
                                            type="email"
                                            className="form-control btn-input btn-radius py-2"
                                            placeholder="Email Address"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <button type="submit" className="signin-btn w-100 py-2 shadow-sm fw-bold" style={{ transition: 'all 0.3s' }} disabled={loading}>
                                            {loading ? 'Sending...' : 'Send Reset Link'}
                                        </button>
                                    </div>
                                    <div className="text-center mt-3">
                                        <Link to="/login" className="links text-decoration-none">Back to Login</Link>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    );
};

export default ForgotPassword;
